import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { IUserFromStorage } from '../../Interfaces/IUser';

declare global {
  interface Window {
    chatwootSDK?: any;
    chatwootSettings?: any;
    $chatwoot?: any;
  }
}

const ChatWootLoader = () => {
  const location = useLocation();

   const userData: IUserFromStorage = JSON.parse(localStorage.getItem('user') || null);
  // console.log(userData ? `Usuario Test Asesoria ID: ${userData?.usuarioTestAsesoriaID}` : 'No user data found');

  useEffect(() => {
    if(!userData) return;

    const isTestUser = true;
    const allowedRoutes = [
      '/producto/2',
      '/preguntasFrecuentes',
      '/aceleradores',
      '/misRutinas',
      '/ejercicioRutina',
      '/cardioRutinas',
      '/tuProgreso',
      '/podcasts',
    ];
    
    const isAllowedRoute = allowedRoutes.some(route => location.pathname.startsWith(route));
    const shouldShowChat = isTestUser && isAllowedRoute;

    // Mostrar u ocultar el bubble según corresponda

    // Inject style to raise the bubble above the bottom nav
    if (!document.getElementById('chatwoot-position-fix')) {
      const style = document.createElement('style');
      style.id = 'chatwoot-position-fix';
      style.textContent = `
        .woot--bubble-holder {
          bottom: 120px !important;
        }
        .woot-widget-bubble {
          bottom: 100px !important;
        }
        .woot-widget-holder {
          bottom: 110px !important;
        }
      `;
      document.head.appendChild(style);
    }

    if (shouldShowChat) {
      if (!document.querySelector('script[data-chatwoot]')) {
        const BASE_URL = 'https://chatwoot-production-382e.up.railway.app';
        const script = document.createElement('script');
        script.dataset.chatwoot = 'true';
        script.src = `${BASE_URL}/packs/js/sdk.js`;
        script.defer = true;
        script.async = true;

        script.onload = () => {

          window.chatwootSettings = {
            "position":"right",
            "type":"expanded_bubble",
            "launcherTitle":"Ayuda"
          };

          window.chatwootSDK?.run({
            websiteToken: 'qJniPhLi6XYKSMUv5rP9hS5w',
            baseUrl: BASE_URL,
          });


          setTimeout(() => {
            window.$chatwoot?.setUser(
              userData.usuarioTestAsesoriaID.toString(),
              {
                email: userData.correo || '',
                name: userData.nombres || '',
                custom_attributes: {
                  objetivo: userData.objetivo,
                }
              }
            );
          }, 100);
          // Mostrar el bubble si existe
          const bubble = document.querySelector('.woot--bubble-holder') as HTMLElement | null;
          if (bubble) bubble.style.display = 'block';
        };

        document.body.appendChild(script);
      } else {

        window.chatwootSettings = {
          "position":"right",
          "type":"expanded_bubble",
          "launcherTitle":"Ayuda"
        };

        setTimeout(() => {
          window.$chatwoot?.setUser(
            userData.usuarioTestAsesoriaID.toString(),
            {
              email: userData.correo || '',
              name: userData.nombres || '',
              custom_attributes: {
                objetivo: userData.objetivo,
              }
            }
          );
        }, 100);
        // Si ya existe, asegurarse de que esté visible
        const bubble = document.querySelector('.woot--bubble-holder') as HTMLElement | null;
        if (bubble) bubble.style.display = 'block';
      }
    } else {
      // Si no corresponde mostrar, ocultar el bubble
      const bubble = document.querySelector('.woot--bubble-holder') as HTMLElement | null;
      if (bubble) bubble.style.display = 'none';
    }

  }, [location.pathname]);

  return null;
};

export default ChatWootLoader;
